import styled, { css } from 'styled-components';
import { DropDown as DropDownComponent } from '@getgrover/ui';

export const DropDownWrapper = styled.div`
    grid-area: color;
    flex-grow: 1;
    min-width: 56%;
    max-width: 80%;

    svg {
        height: 16px;
        width: 16px;
    }

    ${(props) => props.theme.superQuery.all.and.minWidth.desktopMin.css`
        max-width: 80%;
    `};

    ${({ isOrderReview }) =>
        !isOrderReview &&
        css`
            ul {
                position: fixed;
                width: ${({ $width }) => `${$width || 200}px`};
                min-width: 200px;
                transform: ${({ $top }) => `translate(0, ${$top}px)`};
                left: auto;
            }
        `};
`;

export const ItemText = styled.p`
    ${({ theme }) => theme.typography.TinyParagraph};
    flex: 1;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
`;

export const DropDown = styled(DropDownComponent)`
    > div {
        height: 32px;
    }
`;

export const ColorBox = styled.i`
    width: 16px;
    height: 16px;
    background-color: ${({ color }) => color};
    border: 2px solid
        ${({ theme, color }) =>
            color?.toUpperCase() === '#FFFFFF' || color?.toUpperCase() === '#FFF'
                ? `${theme.colors['Level 3']}`
                : 'transparent'};
    border-radius: 50%;
`;
